import { useCallback, useMemo } from 'react';

import {
  UnifiedConnectionDto,
  UnifiedConnectionDtoProvider,
  useCreateConnection,
  useDeleteConnection,
  useListConnections,
  useListContacts
} from '@/api/generated';
import useLocalStorageFF, { LOCAL_STORAGE_KEYS } from '@/utils/useLocalStorageFF';

const useConnections = (provider?: string) => {
  const isSlackEnabled = useLocalStorageFF(LOCAL_STORAGE_KEYS.SLACK);

  const {
    data: connectionsResponse,
    refetch: refetchConnections,
    isLoading: connectionsLoading
  } = useListConnections(
    { provider },
    {
      query: {
        queryKey: ['listConnections']
      }
    }
  );

  const { mutateAsync: mutateCreateConnection } = useCreateConnection();
  const { mutateAsync: mutateDeleteConnection } = useDeleteConnection();

  const createConnection = useCallback(
    async (request: UnifiedConnectionDto) => {
      await mutateCreateConnection({
        data: request
      });
    },
    [mutateCreateConnection]
  );

  const deleteConnection = useCallback(
    async (id: string) => {
      await mutateDeleteConnection({ id });
    },
    [mutateDeleteConnection]
  );

  const conntectionList = useMemo(
    () =>
      connectionsResponse?.items?.filter(conn => {
        if (conn.provider === UnifiedConnectionDtoProvider.slackbot && !isSlackEnabled) {
          return false;
        }
        return true;
      }) || [],
    [connectionsResponse?.items, provider, isSlackEnabled]
  );

  return {
    conntectionList,
    connectionsLoading,
    refetchConnections,
    useListContacts,
    createConnection,
    deleteConnection
  };
};

export default useConnections;
